import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function getConfig() {
  const { data } = await axios.get(`${API}/config`);
  return data;
}

export async function getHeatPoints(start, end) {
  const { data } = await axios.get(`${API}/heat-points`, { params: { start, end } });
  return data;
}

export async function getComparison(aStart, aEnd, bStart, bEnd) {
  const { data } = await axios.get(`${API}/compare`, {
    params: { a_start: aStart, a_end: aEnd, b_start: bStart, b_end: bEnd },
  });
  return data;
}

export async function getRsStatus() {
  const { data } = await axios.get(`${API}/rs/status`);
  return data;
}
export async function getAgriZones() {
  const { data } = await axios.get(`${API}/rs/agri-zones`);
  return data;
}
export async function getNdvi(year) {
  const { data } = await axios.get(`${API}/rs/ndvi/${year}`);
  return data;
}
export async function getChange(yearA, yearB) {
  const { data } = await axios.get(`${API}/rs/change`, { params: { year_a: yearA, year_b: yearB } });
  return data;
}
export async function getCorrelation() {
  const { data } = await axios.get(`${API}/rs/correlation`);
  return data;
}
export async function getEeCorrelation() {
  const { data } = await axios.get(`${API}/ee/correlation`);
  return data;
}
export const RS_EXPORT_URL = `${API}/rs/export`;

export async function getMunicipio() {
  const { data } = await axios.get(`${API}/geo/municipio`);
  return data;
}
export async function getZones() {
  const { data } = await axios.get(`${API}/zones`);
  return data.zones;
}
export async function createZone(zone) {
  const { data } = await axios.post(`${API}/zones`, zone);
  return data;
}
export async function deleteZone(id) {
  const { data } = await axios.delete(`${API}/zones/${id}`);
  return data;
}

export async function getEeStatus() {
  const { data } = await axios.get(`${API}/ee/status`);
  return data;
}
export async function getEeLayer(year, index, source = "landsat") {
  const { data } = await axios.get(`${API}/ee/layer`, { params: { year, index, source } });
  return data;
}
export async function getEeZoneStats(year, index, source = "landsat") {
  const { data } = await axios.get(`${API}/ee/zone-stats`, { params: { year, index, source } });
  return data.zones;
}
export async function postRegionStats(geometry, year, index, source) {
  const { data } = await axios.post(`${API}/ee/region-stats`, { geometry, year, index, source });
  return data;
}
export async function getEePointInfo(lat, lon, year, source = "landsat") {
  const { data } = await axios.get(`${API}/ee/point-info`, { params: { lat, lon, year, source } });
  return data;
}
export async function getEePointSeries(lat, lon, source = "landsat") {
  const { data } = await axios.get(`${API}/ee/point-series`, { params: { lat, lon, source } });
  return data.series;
}
export async function getEeChange(yearA, yearB, index, source, agriOnly = false) {
  const { data } = await axios.get(`${API}/ee/change`, { params: { year_a: yearA, year_b: yearB, index, source, agri_only: agriOnly } });
  return data;
}
export async function getEeLandcover(year = 2021, dataset = "esa") {
  const { data } = await axios.get(`${API}/ee/landcover`, { params: { year, dataset } });
  return data;
}
export async function getAgriLstSeries(source = "landsat") {
  const { data } = await axios.get(`${API}/ee/agri-lst-series`, { params: { source } });
  return data.series;
}
export async function getAirTemperature() {
  const { data } = await axios.get(`${API}/air-temperature`);
  return data;
}
export const AIR_EXPORT_URL = `${API}/air-temperature/export`;
